/**
 * One server-stated wait, counted down — never invented. `start(seconds)`
 * takes the number Auth sent (a 503's or 429's retryAfterSeconds); `left`
 * is the whole seconds remaining, 0 once elapsed or when Auth sent none.
 */

import { useEffect, useState } from 'react';
import { cooldownEndsAt, remainingSeconds } from './otpThrottle';

export function useServerWait(): { left: number; start: (seconds: number | undefined) => void } {
  const [until, setUntil] = useState<number | null>(null);
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (until === null || until <= Date.now()) return;
    const id = setInterval(() => setNow(Date.now()), 500);
    return () => clearInterval(id);
  }, [until]);
  return {
    left: remainingSeconds(until, now),
    start: (seconds) => {
      const t = Date.now();
      setUntil(cooldownEndsAt(seconds, t));
      setNow(t);
    },
  };
}
